/**
 * @fileoverview DELETE handler for the "/companies/:company_id/free_trial/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFreeTrialDevelopersDeveloperIdCacheKeys } from "./constants";
import type {
  DeleteCompaniesCompanyIdFreeTrialDevelopersDeveloperIdProps,
  DeleteFreeTrialDeveloperResult,
} from "./types";

export const deleteFreeTrialDeveloper = reactQueryMutationAdapter(
  companiesCompanyIdFreeTrialDevelopersDeveloperIdCacheKeys,
  (props: DeleteCompaniesCompanyIdFreeTrialDevelopersDeveloperIdProps): Promise<DeleteFreeTrialDeveloperResult> => {
    // manipulate props here as needed {  }

    return fetch(
      `/companies/${props.companyId}/free_trial/developers/${props.developerId}`,
      "DELETE",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
